var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1667 56.875V51.4583C54.1667 48.5852 53.0253 45.8297 50.9936 43.798C48.962 41.7664 46.2065 40.625 43.3333 40.625H21.6667C18.7935 40.625 16.038 41.7664 14.0063 43.798C11.9747 45.8297 10.8333 48.5852 10.8333 51.4583V56.875",
    fill: "#6D0062"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1667 56.875V51.4583C54.1667 48.5852 53.0253 45.8297 50.9936 43.798C48.962 41.7664 46.2065 40.625 43.3333 40.625H21.6667C18.7935 40.625 16.038 41.7664 14.0063 43.798C11.9747 45.8297 10.8333 48.5852 10.8333 51.4583V56.875",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 29.7917C38.4831 29.7917 43.3333 24.9414 43.3333 18.9583C43.3333 12.9752 38.4831 8.125 32.5 8.125C26.5169 8.125 21.6667 12.9752 21.6667 18.9583C21.6667 24.9414 26.5169 29.7917 32.5 29.7917Z",
    fill: "#6D0062",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.492ff33f0383cf9865489b26decf867f.svg";
export { ForwardRef as ReactComponent };